import MailingAddress from 'components/forms/MailingAddress'
import React from 'react'

const ContactInfo = () => {
	return (
		<div>
			<hr className="mt-8 mb-10 text-slate-50" />
			<span className="mb-4 inline-block text-2xl font-medium">Contact Information</span>
			<div className="mb-6 flex items-center gap-5 text-base">
				<svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-slate-400" viewBox="0 0 20 20" fill="currentColor">
					<path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
				</svg>
				<p className="mb-0 text-slate-700">
					<MailingAddress />
				</p>
			</div>
			<div className="mb-6 flex items-center gap-5 text-base">
				<svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-slate-400" viewBox="0 0 20 20" fill="currentColor">
					<path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
				</svg>
				<p className="mb-0 text-slate-700">(866) 810-2665</p>
			</div>
			<div className="flex items-center gap-5 text-base">
				<svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-slate-400" viewBox="0 0 20 20" fill="currentColor">
					<path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
					<path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
				</svg>
				<p className="mb-0 truncate text-slate-700">customercare@americanreading.com</p>
			</div>
		</div>
	)
}

export default ContactInfo
